import { render, staticRenderFns } from "./Single-message.vue?vue&type=template&id=3169503e&scoped=true"
import script from "./Single-message.vue?vue&type=script&lang=js"
export * from "./Single-message.vue?vue&type=script&lang=js"
import style0 from "./Single-message.vue?vue&type=style&index=0&id=3169503e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169503e",
  null
  
)

export default component.exports